<div class="sidebar-container">

  <!-- Sidebar Glow Backdrop -->
  <div class="sidebar-glow"></div>

  <!-- Module Header -->
  <div class="module-header">
    <div class="module-icon-wrapper">
      <div class="module-icon-ring"></div>
      <div class="module-icon">
        @if (moduleIconType === 'SVG') {
          <mat-icon [svgIcon]="moduleIconTitle" class="icon-white icon-lg"></mat-icon>
        }
        @if (moduleIconType === 'MATERIAL') {
          <mat-icon class="icon-white icon-lg">{{ moduleIconTitle }}</mat-icon>
        }
      </div>
    </div>
    <div class="module-info">
      <h2 class="module-title">{{ moduleTitle | translate }}</h2>
      <div class="module-badge">
        <span class="badge-dot"></span>
        <span class="badge-text">Active</span>
      </div>
    </div>
  </div>

  <!-- Divider -->
  <div class="sidebar-divider"></div>

  <!-- Navigation Menu -->
  <nav class="sidebar-nav" aria-label="Sidebar Navigation">
    <mat-nav-list class="nav-list">
      @for (menu of menuData; track menu) {

        <!-- Section Header (Hint) -->
        @if (!menu.children && menu?.isHint) {
          <div class="section-header">
            <span class="section-line"></span>
            <span class="section-label">{{ menu?.name | translate }}</span>
            <span class="section-line"></span>
          </div>
        }

        <!-- Single Menu Item -->
        @if (!menu.children && !menu?.isHint) {
          <a [routerLink]="menu.route"
             routerLinkActive="nav-item--active"
             class="nav-item"
             [matTooltip]="menu.name | translate"
             matTooltipPosition="right"
             matTooltipShowDelay="800">

            <!-- Active indicator bar -->
            <span class="nav-item__indicator"></span>

            <!-- Icon -->
            @if (menu.icon) {
              <span class="nav-item__icon-wrap">
                @if (menu.iconType == 'SVG') {
                  <mat-icon [svgIcon]="menu.icon" class="nav-icon"></mat-icon>
                }
                @if (menu.iconType == 'MATERIAL') {
                  <mat-icon class="nav-icon">{{ menu.icon }}</mat-icon>
                }
              </span>
            }

            <!-- Label -->
            <span class="nav-item__label">{{ menu.name | translate }}</span>

            <!-- Arrow -->
            <span class="nav-item__arrow">
              <mat-icon class="arrow-icon">chevron_right</mat-icon>
            </span>
          </a>
        }

        <!-- Expandable Menu Item -->
        @if (menu?.children) {
          <mat-accordion class="accordion-wrap">
            <mat-expansion-panel
              class="expansion-panel"
              [expanded]="isActiveRoute(menu?.children)"
              hideToggle>

              <!-- Panel Header -->
              <mat-expansion-panel-header class="expansion-header">
                <mat-panel-title class="expansion-title">
                  @if (menu.icon) {
                    <span class="nav-item__icon-wrap">
                      @if (menu.iconType == 'SVG') {
                        <mat-icon [svgIcon]="menu.icon" class="nav-icon"></mat-icon>
                      }
                      @if (menu.iconType == 'MATERIAL') {
                        <mat-icon class="nav-icon">{{ menu.icon }}</mat-icon>
                      }
                    </span>
                  }
                  <span class="nav-item__label">{{ menu?.name | translate }}</span>
                  <span class="expansion-chevron">
                    <mat-icon class="chevron-icon">expand_more</mat-icon>
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <!-- Children -->
              <div class="children-container">
                <div class="children-track"></div>
                @for (menuItemChild of menu?.children; track menuItemChild) {
                  <a [routerLink]="menuItemChild.route"
                     routerLinkActive="child-item--active"
                     class="child-item">

                    <!-- Track dot -->
                    <span class="child-item__dot"></span>

                    @if (menuItemChild?.icon) {
                      @if (menuItemChild.iconType == 'MATERIAL') {
                        <mat-icon class="child-icon">{{ menuItemChild.icon }}</mat-icon>
                      }
                    }

                    <span class="child-item__label">{{ menuItemChild.name | translate }}</span>
                  </a>
                }
              </div>

            </mat-expansion-panel>
          </mat-accordion>
        }
      }
    </mat-nav-list>
  </nav>

  <!-- Bottom User Card -->
  <div class="sidebar-footer">
    <div class="footer-gradient"></div>
  </div>

</div>
